

// import React, { useRef, useEffect, useState } from "react";

// function CanvasEditor({ canvasRef, canvasImages, setCanvasImages }) {
//   const [selectedImageIndex, setSelectedImageIndex] = useState(null);
//   const [action, setAction] = useState(null);
//   const [startMousePosition, setStartMousePosition] = useState({ x: 0, y: 0 });
//   const [startImageProperties, setStartImageProperties] = useState({
//     width: 0,
//     height: 0,
//     rotation: 0,
//     x: 0,
//     y: 0,
//   });

//   const HANDLE_SIZE = 15; // Increase handle size for easier interaction
//   const SIDE_HANDLE_SIZE = 10; // New side handles size


//   const drawCanvas = () => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;
//     const ctx = canvas.getContext("2d");
//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     if (!Array.isArray(canvasImages)) return;

//     canvasImages.forEach((img, index) => {
//       ctx.save();
//       ctx.translate(img.x + img.width / 2, img.y + img.height / 2);
//       ctx.rotate((img.rotation * Math.PI) / 180);
//       ctx.drawImage(
//         img.image,
//         -img.width / 2,
//         -img.height / 2,
//         img.width,
//         img.height
//       );
//       ctx.restore();

//       // Draw resize, rotate, and delete handles if selected
//       if (index === selectedImageIndex) {
//         // Right-side handle for width resize
//         ctx.fillStyle = "purple";
//         ctx.fillRect(img.x + img.width, img.y + img.height / 2 - SIDE_HANDLE_SIZE / 2, SIDE_HANDLE_SIZE, SIDE_HANDLE_SIZE);

//         // Bottom-side handle for height resize
//         ctx.fillStyle = "orange";
//         ctx.fillRect(img.x + img.width / 2 - SIDE_HANDLE_SIZE / 2, img.y + img.height, SIDE_HANDLE_SIZE, SIDE_HANDLE_SIZE);


//         ctx.fillStyle = "blue";
//         ctx.fillRect(img.x + img.width - HANDLE_SIZE, img.y + img.height - HANDLE_SIZE, HANDLE_SIZE, HANDLE_SIZE); // Resize handle

//         ctx.fillStyle = "green";
//         ctx.beginPath();
//         ctx.arc(img.x + img.width - HANDLE_SIZE, img.y + HANDLE_SIZE, HANDLE_SIZE / 2, 0, 2 * Math.PI);
//         ctx.fill(); // Rotate handle

//         ctx.fillStyle = "red";
//         ctx.beginPath();
//         ctx.arc(img.x + HANDLE_SIZE, img.y + HANDLE_SIZE, HANDLE_SIZE / 2, 0, 2 * Math.PI);
//         ctx.fill(); // Delete handle
//       }
//     });
//   };

//   useEffect(() => {
//     drawCanvas();
//   }, [canvasImages, selectedImageIndex]);

//   const handleMouseDown = (e) => {
//     const canvas = canvasRef.current;
//     const rect = canvas.getBoundingClientRect();
//     const mouseX = e.clientX - rect.left;
//     const mouseY = e.clientY - rect.top;

//     let foundImageIndex = null;
//     for (let i = canvasImages.length - 1; i >= 0; i--) {
//       const img = canvasImages[i];
//       if (mouseX >= img.x + img.width - HANDLE_SIZE && mouseY >= img.y + img.height - HANDLE_SIZE) {
//         setAction("resize-aspect"); // Corner handle for aspect ratio
//       } else if (mouseX >= img.x + img.width && mouseY >= img.y + img.height / 2 - SIDE_HANDLE_SIZE / 2) {
//         setAction("resize-width"); // Right-side handle for width
//       } else if (mouseX >= img.x + img.width / 2 - SIDE_HANDLE_SIZE / 2 && mouseY >= img.y + img.height) {
//         setAction("resize-height"); // Bottom-side handle for height
//       }      
//       if (
//         mouseX >= img.x &&
//         mouseX <= img.x + img.width &&
//         mouseY >= img.y &&
//         mouseY <= img.y + img.height
//       ) {
//         foundImageIndex = i;
//         break;
//       }
//     }

//     setSelectedImageIndex(foundImageIndex);
//     if (foundImageIndex !== null) {
//       const img = canvasImages[foundImageIndex];
//       setStartMousePosition({ x: mouseX, y: mouseY });
//       setStartImageProperties({
//         width: img.width,
//         height: img.height,
//         rotation: img.rotation,
//         x: img.x,
//         y: img.y,
//       });

//       // Check if user clicked on resize, rotate, or delete handles
//       if (
//         mouseX >= img.x + img.width - HANDLE_SIZE &&
//         mouseY >= img.y + img.height - HANDLE_SIZE
//       ) {
//         setAction("resize");
//       } else if (
//         Math.hypot(mouseX - (img.x + img.width - HANDLE_SIZE), mouseY - (img.y + HANDLE_SIZE)) <= HANDLE_SIZE / 2
//       ) {
//         setAction("rotate");
//       } else if (
//         Math.hypot(mouseX - (img.x + HANDLE_SIZE), mouseY - (img.y + HANDLE_SIZE)) <= HANDLE_SIZE / 2
//       ) {
//         removeImageFromCanvas(foundImageIndex);
//         return;
//       } else {
//         setAction("drag");
//       }
//     }
//   };

//   const handleMouseMove = (e) => {
//     if (!action || selectedImageIndex === null) return;

//     const canvas = canvasRef.current;
//     const rect = canvas.getBoundingClientRect();
//     const mouseX = e.clientX - rect.left;
//     const mouseY = e.clientY - rect.top;

//     setCanvasImages((prev) =>
//       prev.map((img, i) => {
//         if (i !== selectedImageIndex) return img;

//         if (action === "drag") {
//           return {
//             ...img,
//             x: startImageProperties.x + (mouseX - startMousePosition.x),
//             y: startImageProperties.y + (mouseY - startMousePosition.y),
//           };
//         } else if (action === "resize-aspect") {
//             const dx = mouseX - startMousePosition.x;
//             const dy = mouseY - startMousePosition.y;
//             const scaleFactor = Math.max(dx / startImageProperties.width, dy / startImageProperties.height);
//             return {
//               ...img,
//               width: Math.max(20, startImageProperties.width * (1 + scaleFactor)),
//               height: Math.max(20, startImageProperties.height * (1 + scaleFactor)),
//             };
//           } else if (action === "resize-width") {
//             return { ...img, width: Math.max(20, startImageProperties.width + (mouseX - startMousePosition.x)) };
//           } else if (action === "resize-height") {
//             return { ...img, height: Math.max(20, startImageProperties.height + (mouseY - startMousePosition.y)) };
//         } else if (action === "rotate") {
//           const centerX = img.x + img.width / 2;
//           const centerY = img.y + img.height / 2;
//           const deltaX = mouseX - centerX;
//           const deltaY = mouseY - centerY;
//           const angle = (Math.atan2(deltaY, deltaX) * 180) / Math.PI;
//           return { ...img, rotation: angle };
//         }
//         return img;
//       })
//     );
//   };

//   const handleMouseUp = () => {
//     setAction(null);
//   };

//   const removeImageFromCanvas = (index) => {
//     setCanvasImages((prev) => prev.filter((_, i) => i !== index));
//     setSelectedImageIndex(null);
//     setAction(null);
//   };

//   return (
//     <canvas
//       ref={canvasRef}
//       width={900}
//       height={650}
//       style={{ border: "1px solid black", cursor: "pointer" }}
//       onMouseDown={handleMouseDown}
//       onMouseMove={handleMouseMove}
//       onMouseUp={handleMouseUp}
//       onMouseLeave={handleMouseUp}
//     />
//   );
// }

// export default CanvasEditor;




import React, { useRef, useEffect, useState } from "react";

function CanvasEditor({ canvasRef, canvasImages, setCanvasImages }) {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [action, setAction] = useState(null);
  const [startMousePosition, setStartMousePosition] = useState({ x: 0, y: 0 });
  const [startImageProperties, setStartImageProperties] = useState({
    width: 0,
    height: 0,
    rotation: 0,
    x: 0,
    y: 0,
  });

  const HANDLE_SIZE = 15; // Increase handle size for easier interaction
  const SIDE_HANDLE_SIZE = 10; // New side handles size

  const drawCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (!Array.isArray(canvasImages)) return;

    canvasImages.forEach((img, index) => {
      ctx.save();
      ctx.translate(img.x + img.width / 2, img.y + img.height / 2);
      ctx.rotate((img.rotation * Math.PI) / 180);
      ctx.drawImage(
        img.image,
        -img.width / 2,
        -img.height / 2,
        img.width,
        img.height
      );
      ctx.restore();

      // Draw resize, rotate, and delete handles if selected
      if (index === selectedImageIndex) {
        // Right-side handle for width resize
        ctx.fillStyle = "purple";
        ctx.fillRect(
          img.x + img.width,
          img.y + img.height / 2 - SIDE_HANDLE_SIZE / 2,
          SIDE_HANDLE_SIZE,
          SIDE_HANDLE_SIZE
        );

        // Bottom-side handle for height resize
        ctx.fillStyle = "orange";
        ctx.fillRect(
          img.x + img.width / 2 - SIDE_HANDLE_SIZE / 2,
          img.y + img.height,
          SIDE_HANDLE_SIZE,
          SIDE_HANDLE_SIZE
        );

        // Corner handle for aspect ratio resize
        ctx.fillStyle = "blue";
        ctx.fillRect(
          img.x + img.width - HANDLE_SIZE,
          img.y + img.height - HANDLE_SIZE,
          HANDLE_SIZE,
          HANDLE_SIZE
        );

        // Rotate handle
        ctx.fillStyle = "green";
        ctx.beginPath();
        ctx.arc(
          img.x + img.width - HANDLE_SIZE,
          img.y + HANDLE_SIZE,
          HANDLE_SIZE / 2,
          0,
          2 * Math.PI
        );
        ctx.fill();

        // Delete handle
        ctx.fillStyle = "red";
        ctx.beginPath();
        ctx.arc(
          img.x + HANDLE_SIZE,
          img.y + HANDLE_SIZE,
          HANDLE_SIZE / 2,
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
    });
  };

  useEffect(() => {
    drawCanvas();
  }, [canvasImages, selectedImageIndex]);

  const handleMouseDown = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    let foundImageIndex = null;
    for (let i = canvasImages.length - 1; i >= 0; i--) {
      const img = canvasImages[i];

      // Check for handle clicks
      if (
        mouseX >= img.x + img.width - HANDLE_SIZE &&
        mouseY >= img.y + img.height - HANDLE_SIZE
      ) {
        setAction("resize-aspect"); // Corner handle for aspect ratio
        foundImageIndex = i;
        break;
      } else if (
        mouseX >= img.x + img.width &&
        mouseY >= img.y + img.height / 2 - SIDE_HANDLE_SIZE / 2
      ) {
        setAction("resize-width"); // Right-side handle for width
        foundImageIndex = i;
        break;
      } else if (
        mouseX >= img.x + img.width / 2 - SIDE_HANDLE_SIZE / 2 &&
        mouseY >= img.y + img.height
      ) {
        setAction("resize-height"); // Bottom-side handle for height
        foundImageIndex = i;
        break;
      } else if (
        Math.hypot(
          mouseX - (img.x + img.width - HANDLE_SIZE),
          mouseY - (img.y + HANDLE_SIZE)
        ) <= HANDLE_SIZE / 2
      ) {
        setAction("rotate"); // Rotate handle
        foundImageIndex = i;
        break;
      } else if (
        Math.hypot(
          mouseX - (img.x + HANDLE_SIZE),
          mouseY - (img.y + HANDLE_SIZE)
        ) <= HANDLE_SIZE / 2
      ) {
        removeImageFromCanvas(i); // Delete handle
        return;
      } else if (
        mouseX >= img.x &&
        mouseX <= img.x + img.width &&
        mouseY >= img.y &&
        mouseY <= img.y + img.height
      ) {
        setAction("drag"); // Drag action
        foundImageIndex = i;
        break;
      }
    }

    setSelectedImageIndex(foundImageIndex);
    if (foundImageIndex !== null) {
      const img = canvasImages[foundImageIndex];
      setStartMousePosition({ x: mouseX, y: mouseY });
      setStartImageProperties({
        width: img.width,
        height: img.height,
        rotation: img.rotation,
        x: img.x,
        y: img.y,
      });
    }
  };

  const handleMouseMove = (e) => {
    if (!action || selectedImageIndex === null) return;

    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    setCanvasImages((prev) =>
      prev.map((img, i) => {
        if (i !== selectedImageIndex) return img;

        if (action === "drag") {
          return {
            ...img,
            x: startImageProperties.x + (mouseX - startMousePosition.x),
            y: startImageProperties.y + (mouseY - startMousePosition.y),
          };
        } else if (action === "resize-aspect") {
          const dx = mouseX - startMousePosition.x;
          const dy = mouseY - startMousePosition.y;
          const scaleFactor = Math.max(
            dx / startImageProperties.width,
            dy / startImageProperties.height
          );
          return {
            ...img,
            width: Math.max(20, startImageProperties.width * (1 + scaleFactor)),
            height: Math.max(20, startImageProperties.height * (1 + scaleFactor)),
          };
        } else if (action === "resize-width") {
            return { 
                ...img, 
                width: Math.max(20, startImageProperties.width + (mouseX - startMousePosition.x)) 
            };
        } else if (action === "resize-height") {
            return { 
                ...img, 
                height: Math.max(20, startImageProperties.height + (mouseY - startMousePosition.y)) 
            };
        } else if (action === "rotate") {
          const centerX = img.x + img.width / 2;
          const centerY = img.y + img.height / 2;
          const deltaX = mouseX - centerX;
          const deltaY = mouseY - centerY;
          const angle = (Math.atan2(deltaY, deltaX) * 180) / Math.PI;
          return { ...img, rotation: angle };
        }
        return img;
      })
    );
  };

  const handleMouseUp = () => {
    setAction(null);
  };

  const removeImageFromCanvas = (index) => {
    setCanvasImages((prev) => prev.filter((_, i) => i !== index));
    setSelectedImageIndex(null);
    setAction(null);
  };

  return (
    <canvas
      ref={canvasRef}
      width={900}
      height={650}
      style={{ border: "1px solid black", cursor: "pointer" }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    />
  );
}

export default CanvasEditor;